"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateDoiSettings = exports.UpdateDoiSettingsActionTypes = exports.updateDoiSettings = exports.loadDoiSettings = exports.FetchDoiSettings = exports.FetchDoiSettingsActionTypes = exports.DoiSettingsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var DoiSettingsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_DOI_SETTINGS: null,
  LOAD_DOI_SETTINGS: null,
  UPDATE_DOI_SETTINGS: null
}, _constants.DOI_SETTINGS);
exports.DoiSettingsActionTypes = DoiSettingsActionTypes;
var FetchDoiSettingsActionTypes = (0, _actions.createRequestTypes)(DoiSettingsActionTypes.FETCH_DOI_SETTINGS);
exports.FetchDoiSettingsActionTypes = FetchDoiSettingsActionTypes;
var FetchDoiSettings = (0, _actions.createRequestActions)(FetchDoiSettingsActionTypes);
exports.FetchDoiSettings = FetchDoiSettings;
var loadDoiSettings = (0, _fluxActions.createAction)(DoiSettingsActionTypes.LOAD_DOI_SETTINGS);
exports.loadDoiSettings = loadDoiSettings;
var updateDoiSettings = (0, _fluxActions.createAction)(DoiSettingsActionTypes.UPDATE_DOI_SETTINGS, (0, _actions.mapPayloadTo)('data'));
exports.updateDoiSettings = updateDoiSettings;
var UpdateDoiSettingsActionTypes = (0, _actions.createRequestTypes)(DoiSettingsActionTypes.UPDATE_DOI_SETTINGS);
exports.UpdateDoiSettingsActionTypes = UpdateDoiSettingsActionTypes;
var UpdateDoiSettings = (0, _actions.createRequestActions)(UpdateDoiSettingsActionTypes);
exports.UpdateDoiSettings = UpdateDoiSettings;